export default __webpack_public_path__ + "static/media/eatPlane.5210ac90.webp";